export enum RouteNames {
  PERSONAL_INFO = 'personal-info',
  CONNECT_WALLET = 'connect-wallet',
  CONTACT = 'contact',
  FAQ = 'faq',
  UPLOAD_ARTWORK = 'upload-artwork',
  HOME = '/',
  EXPLORE = '/explore',
  CURRENT_USER = '/user/:uuid'
}